import { useTheme } from "@emotion/react";
import {
  AttachMoneyOutlined,
  BarChartOutlined,
  ConnectWithoutContactOutlined,
  DashboardOutlined,
  Delete,
  Edit,
  GroupOutlined,
  HomeOutlined,
  InsertChartOutlined,
  KeyOutlined,
  ManageAccountsOutlined,
  MoreVert,
  PermIdentityOutlined,
  RouterOutlined,
  SecurityOutlined,
  SupportAgentOutlined,
  TextSnippetOutlined,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Chip,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Snackbar,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { cloneElement, useState } from "react";
import useStyles from "./styles";
import api from "../../services/api";
import InternoModalConfirmacaoSaida from "../modalSaindoDaPagina";
import ModalCreatePermissao from "../modalCreatePermissao";
import { set } from "react-hook-form";
// Mapa de ícones por rota do lado interno (default)
const iconMapInterno = {
  "/interno/resumo": <HomeOutlined />,
  "/interno/dash": <BarChartOutlined />,
  "/interno/home/perfil": <PermIdentityOutlined />,
  "/interno/relatorio": <TextSnippetOutlined />,
  "/interno/relatorio-reincidencia": <InsertChartOutlined />,
  "/interno/suporte": <SupportAgentOutlined />,
  "/interno/financeiro": <AttachMoneyOutlined />,
  "/interno/cadastroHosts": <RouterOutlined />,
  "/interno/clientesSwap": <ConnectWithoutContactOutlined />,
  "/interno/dash/fortigate": <SecurityOutlined />,
  "/interno/suporte/fluxoOs": <InsertChartOutlined />, // IXC
  "/interno/suporte/os": <ManageAccountsOutlined />,
};

// Endpoints do lado interno (default). O portal do cliente injeta os seus.
const endpointsInterno = {
  delete: "/delete/PermissaoUser",
  allRoutes: "find/allRoutes",
  create: "create/permissaoUser",
  edit: "/edit/permissaoUser",
};

export default function CardPermissao(params) {
  const {
    permissao = "ADM",
    colorPermissao = "",
    countUsers = 10,
    arrayPermissoes = [],
    descricao = "",
    totalAcessos = 0,
    permissaoObject = {},
    setAllPermissoes = () => {},
    allPermissoes = [],
    setSnackbar = () => {},
    apiInstance = api,
    endpoints = endpointsInterno,
    iconMap = iconMapInterno,
    iconMapMenu = {},
    permissaoProtegida = "TÉCNICO",
    filtrarRota = null,
    somenteLeitura = false,
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPermissao, setSelectedPermissao] = useState(null);
  const [loading, setLoading] = useState(false);
  const open = Boolean(anchorEl);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [permissaoEdit, setPermissaoEdit] = useState({
    codigoPermissao: "",
    descricao: "",
    color: "",
  });
  const [routesSelect, setRoutesSelect] = useState([]);
  const flattenPermissions = (data) => {
    let result = [];

    data.forEach((item) => {
      // 1. Adicionamos o item atual (apenas com as propriedades desejadas)
      result.push({
        id: item.id,
        path: item.path,
      });

      // 2. Se o item tiver filhos e o array de filhos não estiver vazio,
      // chamamos a função novamente para processar os filhos
      if (item.children && item.children.length > 0) {
        const childrenFlattened = flattenPermissions(item.children);
        result = result.concat(childrenFlattened);
      }
    });

    return result;
  };
  const handleClick = (event, permissao) => {
    setAnchorEl(event.currentTarget);
    setSelectedPermissao(permissao);
    setPermissaoEdit({
      id: permissao?.id,
      codigoPermissao: permissao?.codigoPermissao,
      descricao: permissao?.descricao,
      color: permissao?.color,
    });
    const flatArray = flattenPermissions(arrayPermissoes);
    setRoutesSelect(flatArray);
  };
  const handleClose = (e) => {
    setAnchorEl(null);
  };

  const generatePages = (routes, theme) => {
    return routes
      ?.map((route) => {
        // Busca o ícone pela rota (path)
        const iconElement = iconMap[route.path];

        const icon = iconElement ? (
          cloneElement(iconElement, {
            sx: { color: theme.palette.primary.main },
          })
        ) : (
          // Ícone padrão caso a rota não esteja no mapa
          <DashboardOutlined sx={{ color: theme.palette.primary.main }} />
        );

        return {
          label: route.pagina,
          icon: icon,
          // Mapeia os nomes das subpáginas se houver children
          subpages: route.children
            ? route?.children?.map((child) => child?.pagina)?.reverse()
            : [],
        };
      })
      ?.reverse(); // Inverte a ordem para exibir as últimas rotas primeiro
  };

  const pages = generatePages(arrayPermissoes, theme);

  const deletePermissao = async () => {
    try {
      const response = await apiInstance.post(endpoints.delete, {
        permissaoId: permissaoObject?.id,
      });
      const newPermissoes = allPermissoes?.filter(
        (perm) => perm?.id !== permissaoObject?.id,
      );
      setAllPermissoes(newPermissoes);
      setSnackbar({
        children: "Permissão excluida com sucesso!",
        severity: "success",
      });
    } catch (error) {
      console.error(error);
      setSnackbar({
        children:
          error?.response?.data?.error || "Error: Falha ao excluir permissão",
        severity: "error",
      });
    } finally {
      setAnchorEl(null);
    }
  };

  return (
    <>
      <Accordion variant="outlined" sx={styles.containerPaper}>
        <AccordionSummary
          sx={{
            "& .MuiAccordionSummary-content": {
              overflow: "hidden", // Impede que o conteúdo interno force a expansão
              width: "100%", // Garante que o container ocupe o espaço correto
            },
          }}
        >
          <Box sx={{ width: "100%", overflow: "hidden" }}>
            <Box
              sx={{
                ...styles.containerHeader,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Chip
                label={permissao}
                size="small"
                sx={{
                  ...styles.chip,
                  backgroundColor: colorPermissao,
                  flexShrink: 1, // Permite encolher
                  minWidth: 0, // Essencial para o truncamento em flexbox
                  "& .MuiChip-label": {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                }}
              />
              <IconButton
                sx={{ flexShrink: 0 }} // Impede que o botão suma/encolha
                onClick={(e) => {
                  handleClick(e, permissaoObject);
                  e.stopPropagation();
                }}
              >
                <MoreVert />
              </IconButton>
            </Box>

            {/* Resto do seu código (Descrição e Infos) */}
            <Box sx={styles.boxDescription}>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ ...styles.description, noWrap: true }}>
                  <strong>Descrição:</strong> {descricao}
                </Typography>
              </Box>
              <Box sx={styles.containerInfo}>
                <Box
                  sx={{
                    ...styles.containerHeaderUser,
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <GroupOutlined sx={styles.icon} />
                  <Typography sx={styles.titleUsers}>
                    {countUsers} usuário{countUsers > 1 ? "s" : ""}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    ...styles.containerHeaderUser,
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <KeyOutlined sx={styles.icon} />
                  <Typography sx={styles.titleUsers}>
                    {totalAcessos} acesso{totalAcessos > 1 ? "s" : ""}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </AccordionSummary>
        <Divider />
        <AccordionDetails>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography sx={{ fontWeight: "bold", fontSize: "14px" }}>
              Acesso liberado para:
            </Typography>
            {pages?.map((page, index) => (
              <Paper
                elevation={0}
                variant="outlined"
                sx={styles.paperPermissao}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  {page?.icon || <></>}
                  <Typography sx={{ fontWeight: "bold" }}>
                    {page?.label}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {page?.subpages?.map((subpage, index) => (
                    <Chip
                      sx={{
                        borderRadius: "6px",
                      }}
                      size="small"
                      label={subpage}
                    />
                  ))}
                </Box>
              </Paper>
            ))}
          </Box>
        </AccordionDetails>
      </Accordion>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        <MenuItem
          onClick={() => {
            setOpenEdit(true);
            setAnchorEl(null);
          }}
          disabled={somenteLeitura}
        >
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          <ListItemText>Editar</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            setOpenDeleteModal(true);
            setAnchorEl(null);
          }}
          disabled={
            somenteLeitura ||
            permissaoObject?.codigoPermissao === permissaoProtegida
          }
        >
          <ListItemIcon>
            <Delete color="error" fontSize="small" />
          </ListItemIcon>
          <ListItemText>Excluir</ListItemText>
        </MenuItem>
      </Menu>
      <InternoModalConfirmacaoSaida
        openConfirmacao={openDeleteModal}
        deleteLoad={loading}
        setOpenConfirmacao={setOpenDeleteModal}
        execute={deletePermissao}
        title={"Atenção"}
        severity={"error"}
        contentText={
          "Ao excluir esta permissão, ela será removida de todos os usuários que a possuem. Tem certeza que deseja excluir?"
        }
        confirmText={"Excluir"}
      />

      <ModalCreatePermissao
        setRoutesSelect={setRoutesSelect}
        routesSelect={routesSelect}
        setOpen={setOpenEdit}
        open={openEdit}
        permissao={permissaoEdit}
        setPermissao={setPermissaoEdit}
        setAllPermissoes={setAllPermissoes}
        isEdit={true}
        setSnackbar={setSnackbar}
        permissaoObject={permissaoObject}
        apiInstance={apiInstance}
        endpoints={endpoints}
        iconMap={iconMapMenu}
        permissaoProtegida={permissaoProtegida}
        filtrarRota={filtrarRota}
      />
    </>
  );
}
